export default __webpack_public_path__ + "static/images/referral2_3_mail-0876aa89188db8b958efb4faabdd7199.png";